import { Divider, Flex, message, Spin } from "antd";
import { useContext, useEffect, useState } from "react";
import { fetchData } from "../../utils/fetch";
import { LanguageContext } from "../../utils/lang_provider";

export function Contact() {
    const [width, setWidth] = useState(window.innerWidth);
    const backendUrl = process.env.REACT_APP_BACKEND_URL;
    const { language } = useContext(LanguageContext);
    const [ mainBuilding, setMainBuilding ] = useState(null);
    const [ productionHall, setProductionHall ] = useState(null);
    const [ information, setInformation ] = useState(null);

    async function loadConditions() {
        try {
            const res = await fetch(`${backendUrl}/front/business_conditions?language=sk`);
            if (!res.ok) throw new Error("Failed to fetch");
            const blob = await res.blob();
            const url = URL.createObjectURL(blob);
            window.open(url, "_blank");
        } catch (err) {
            message.error("Failed to load PDF: " + err.message);
        }
    }

    async function loadGdpr() {
        try {
            const res = await fetch(`${backendUrl}/front/gdpr?language=sk`);
            if (!res.ok) throw new Error("Failed to fetch");
            const blob = await res.blob();
            const url = URL.createObjectURL(blob);
            window.open(url, "_blank");
        } catch (err) {
            message.error("Failed to load PDF: " + err.message);
        }
    }

    useEffect(() => {
        async function loadWebObjects() {
            try {
                const data = await fetchData(`front/web-objects/contact_page`, language)
                setMainBuilding(data[0]);
                setProductionHall(data[1]);
                setInformation(data[2]);
            } catch (error) {
            }
        }
        loadWebObjects();
    }, [language]);

    const handleResize = () => {
        setWidth(window.innerWidth);
    }

    window.addEventListener('resize', handleResize);

    if (!mainBuilding || !productionHall || !information) {
        return <Spin style={{padding: "200px"}}></Spin>
    }

    return (
        <Flex wrap vertical style={{margin: width > 1343 ? "0 10% 0 10%" : "0 5% 0 5%"}}>
            <Divider orientation="left" children={<h2 style={{color: "white"}}>{mainBuilding.title}</h2>}></Divider>
            <Flex wrap vertical>
                <Flex wrap justify="space-around" className="main-building">
                    <div dangerouslySetInnerHTML={{ __html: mainBuilding.content }} />
                    <iframe src={mainBuilding.settings} width={width> 1343 ? "600" : "100%"} height={width > 1343 ? "450" : "100%"} style={{margin: " 0 30px 30px 30px", border:"0"}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"/>
                </Flex> 
            </Flex>
            <Flex wrap vertical>
                <Divider orientation="right" children={<h2 style={{color: "white"}}>{productionHall.title}</h2>}></Divider>
                <Flex wrap={width > 1343 ? "wrap" : "wrap-reverse"} justify="space-around" className="main-building">
                    <iframe src={productionHall.settings} width={width > 1343 ? "600" : "100%"} height={width > 1343 ? "450" : "100%"} style={{margin: " 0 30px 30px 30px", border: "0"}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                    <div dangerouslySetInnerHTML={{ __html: productionHall.content }} />
                </Flex> 
            </Flex>
            <Divider children={<h2 style={{color: "white"}}>{information.title}</h2>}/>
            <Flex align="center" justify="space-evenly">
                <div dangerouslySetInnerHTML={{__html: information.content}}></div>
                <Flex justify="center"vertical>
                    <a onClick={loadConditions}><p>{language === 'sk' ? "Obchodné podmienky" : "Business conditions"}</p></a>
                    <a onClick={loadGdpr}><p>GDPR</p></a>
                </Flex>
            </Flex>
        </Flex>
    )
}